import { render, staticRenderFns } from "./BaseActionButton.vue?vue&type=template&id=242a9e06&scoped=true&"
import script from "./BaseActionButton.vue?vue&type=script&lang=js&"
export * from "./BaseActionButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseActionButton.vue?vue&type=style&index=0&id=242a9e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a9e06",
  null
  
)

export default component.exports